import { Reducer } from 'redux';
import { IGameState } from '../Game/IGameState';

export const WorldReducer: Reducer<IGameState> = (
    state: IGameState,
): IGameState => {return state};
